import '@progress/kendo-theme-default/dist/all.css';
import { Routes, Route, useLocation, Navigate, useNavigate, useSearchParams } from "react-router-dom";
import { Login } from './screens/authFlow/login';
import { } from './navigation/protected';
import { ClientDashBoard } from './screens/appFlow/client-dashboard';
import { ProtectedRoute } from './navigation/private'
import { Home } from "./screens/appFlow/client-dashboard/home";
import { Messaging } from "./screens/appFlow/client-dashboard/messaging";

import localKey from "./storage/localKey";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { customAxios } from "./services/apiConfig/useExPressApi";
import { ApiRoutes } from "./services/apiConfig/apiEdndpoints";
import { routes } from "./navigation/appRoutes";
import { getClientDetailedInfo, loginAction, saveAuthResponse, saveClientDetailedInfo, setAppIsImpersonate } from "./redux/actions";
import { Diagnosis } from "./screens/appFlow/client-dashboard/diagnosis";
import { CarePlan } from "./screens/appFlow/client-dashboard/care-plan";
import { Appointments } from "./screens/appFlow/client-dashboard/appointments";
import { NotificationPreferences } from "./screens/appFlow/client-dashboard/notification-preferences";
import  DEVELOPMENT_CONFIG  from "./config"
import { Loader } from '@progress/kendo-react-all';
import Loading from './components/loader/loader';

const App = () => {
  const location = useLocation()
  let token = localStorage.getItem(localKey.AUTH_TOKEN);
  const dispatch = useDispatch()
  const [isSessionChecked, setIsSessionChecked] = useState(false)
  const [isFromAdminApp, setIsFromAdminApp] = useState(location.pathname === "/impersonate")
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();


  useEffect(() => {
    if (!isSessionChecked) {
      if(isFromAdminApp){
        checkUserSessionFromClient()
      }
      else if (token && token != null && token.length > 0) {
        checkUserSession()
      } else {
        setIsSessionChecked(true)
      }
    }
  }, [isSessionChecked])

  async function checkUserSession() {
    const sessionResp = await customAxios.get(`${ApiRoutes.GET_CLIENT}`);
    if (!sessionResp || !sessionResp.status) {
      localStorage.clear();
      window.location.href = routes.auth;
    }
    else {
      dispatch(saveClientDetailedInfo((sessionResp as unknown as { resultData: any }).resultData));
      navigate(routes.home);
    }
    setIsSessionChecked(true)
  }

  function searchToObject() {
    var pairs = location.search.substring(1).split("&"),
      obj = {},
      pair,
      i;

    for (i in pairs) {
      if (pairs[i] === "") continue;

      pair = pairs[i].split("=");
      (obj as { [key: string]: any })[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
    }

    return obj;
  }

  async function checkUserSessionFromClient() {
    if(token){
      localStorage.clear()
    }
    localStorage.setItem(DEVELOPMENT_CONFIG.IS_IMPERSONATE, "false");
    if ((searchParams.has("docId") && searchParams.has("token")) || (searchParams.has("token") && searchParams.has("SessionOrigin"))) {
      var obj = searchToObject();
      let sessionResp = null;
      await customAxios.get(`${ApiRoutes.GET_BYPASS_TOKEN}?token=${encodeURIComponent((obj as { token: string }).token)}&sessionOrigin=${searchParams.get("SessionOrigin")}`)
        .then((response) => {
          sessionResp = (response as any).resultData;
          if (!sessionResp || !response || !response.status) {
            localStorage.clear();
            window.location.href = "/login";
          } else {
              //CLIENT IMPERSONATE
            dispatch(saveAuthResponse(sessionResp));
            dispatch(setAppIsImpersonate(true));
            localStorage.setItem(DEVELOPMENT_CONFIG.IS_IMPERSONATE, "true");
            localStorage.setItem(localKey.AUTH_TOKEN, sessionResp?.token);
            localStorage.setItem(DEVELOPMENT_CONFIG.REFRESH_TOKEN, sessionResp.refreshToken);
            navigate(routes.home);
            dispatch(getClientDetailedInfo())
          }
        })
    }
    setIsSessionChecked(true)
  }


  if (location.pathname === "/") {
    if (token === null || "") {
      return <Navigate to={"/logIn"} />;
    }
    if (token !== null || "") {
      return <Navigate to="/home" />;
    }
  }

  if(!isSessionChecked){
    return <Loading></Loading>
  }

  return (
    // <Navigation />
    <div>
      {token ? <ClientDashBoard /> : null}
      <Routes>
        <Route path="/login" element={<Login />} />

        <Route path="/home" element={
          <ProtectedRoute>
            <Home />
          </ProtectedRoute>
        }
        />
        <Route path="/diagnosis" element={
          <ProtectedRoute>
            <Diagnosis />
          </ProtectedRoute>
        }
        />
         <Route path="/appointment" element={
          <ProtectedRoute>
            <Appointments />
          </ProtectedRoute>
        }
        />
         <Route path="/care-plan" element={
          <ProtectedRoute>
            <CarePlan />
          </ProtectedRoute>
        }
        />
        <Route path="/message" element={
          <ProtectedRoute>
            <Messaging />
          </ProtectedRoute>
        }
        />
        <Route path="/notification" element={
          <ProtectedRoute>
            <NotificationPreferences />
          </ProtectedRoute>
        }
        />
      

     

      </Routes>


    </div>

  )

}



export default App;